"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CraftHeritage() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="craft-heritage" className="bg-secondary py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645038/img/bakers_hands_flour_bw.png" alt="Baker's hands dusted with flour working with artisan dough" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            {}
            <div className="absolute inset-0 bg-black/5 mix-blend-multiply pointer-events-none"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <span className="text-sm font-bold tracking-widest uppercase text-primary mb-6 block font-default">
              Our Philosophy
            </span>
            
            <p className="font-serif text-3xl md:text-4xl lg:text-5xl text-secondary-foreground leading-relaxed md:leading-relaxed lg:leading-relaxed mb-8">
              We craft artisan breads and delicate pastries using premium ingredients and time‑honored techniques, delivering comforting nostalgia with every bite.
            </p>
            
            <p className="text-lg text-secondary-foreground/80 font-sans leading-relaxed mb-10 max-w-lg">
              CRUST is a boutique bakery committed to quality and community sourcing. Our dedication to the tactile, rustic nature of baking ensures that every golden crust and artistic decoration is made with love and care.
            </p>
            
            
          </div>

        </div>
      </div>
    </section>;
}